module.exports = __webpack_public_path__ + "static/media/stats-down.b111c710.svg";